/**
 * get tag lists for cx interaction form
 */
 export class GetInteractionTagLists {
    static readonly type = '[TagLists] GetInteractionTagLists';
    constructor() { }
}


/**
 * Save CxInteraction
 */
export class SaveCxInteraction {
    static readonly type = '[CxInteraction] SaveCxInteraction';
    constructor(public cxInteractionInfo: object, public form: any, public directive, public cxComponent) { }
}

export class PushInteractionAlert {
    static readonly type = '[Alert] PushInteractionAlert';
    constructor(public alertLevel: any, public message: string) {}
  }
